<template>
  <div
    v-if="isClickAndCollectEligible"
    class="pa-store-check"
  >
    <div class="pasc-dot">
      <fn-icon
        icon="full-dot"
        size="xxs"
        token-color="color-general-text-status-positive-default"
      />
      {{ $t('shipping.modes.clickAndCollect') }} {{ $t('cart.deliveryMethods.pickupFromStoreAvailable') }}
    </div>
  </div>
  <div
    v-else
    class="pa-store-check"
  >
    <div class="pasc-dot">
      <fn-icon
        icon="outer-dot"
        size="xxs"
        token-color="color-general-text-status-negative-default"
      />
      {{ $t('shipping.modes.clickAndCollect') }} {{ $t('cart.deliveryMethods.pickupFromStoreUnavailable') }}
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  isClickAndCollectEligible: boolean;
}>();
</script>

<style lang="scss" scoped>
.pa-store-check {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: math.div($pad, 2);
  margin-bottom: math.div($pad, 2);
}

.pasc-dot {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: math.div($pad, 2);
}
</style>
